import type { IntlShape } from 'react-intl'

export function getMaldivesMobileCalendarPriceContextLabels(
  intl: IntlShape,
  nights: number,
  priceMode: 'total' | 'perPerson',
  adultCount: number,
) {
  const nightsAndFlightsText = intl.formatMessage(
    {
      id: 'r484bkJ_LnqWqW8S-s9D',
      defaultMessage: '{nights, plural, one {# night} other {# nights}} & flights',
      description: 'Label showing number of nights and flights included in charter bundle',
    },
    { nights },
  )
  const nightsText = intl.formatMessage(
    {
      id: '1n-cvJDlrd6Hw6g9lVNj',
      defaultMessage: '{nights, plural, one {# night} other {# nights}}',
      description: 'Label showing number of nights in a charter bundle mobile calendar date row',
    },
    { nights },
  )
  const priceContextText = priceMode === 'perPerson' ? intl.formatMessage(
    {
      id: 'FFWFCkEAyaLLXWRm8l1w',
      defaultMessage: '{nightsAndFlights}, per adult from',
      description: 'Context label above per-person price in the Maldives charter mobile calendar date card',
    },
    { nightsAndFlights: nightsAndFlightsText },
  ) : intl.formatMessage(
    {
      id: 'm16_LsRFxUEbDvpCUofD',
      defaultMessage: '{nightsAndFlights}, {adultCount, plural, one {# adult} other {# adults}} from',
      description: 'Context label above total price in the Maldives charter mobile calendar date card',
    },
    { nightsAndFlights: nightsAndFlightsText, adultCount },
  )
  const expandedPriceContextText = priceMode === 'perPerson' ? intl.formatMessage(
    {
      id: 'Kp-StujCqMadjaRIuQgy',
      defaultMessage: '{nightsAndFlights}, per adult',
      description: 'Context label shown beside the expanded fare options toggle in the Maldives charter mobile calendar date card',
    },
    { nightsAndFlights: nightsAndFlightsText },
  ) : intl.formatMessage(
    {
      id: 'JLb1JH1o5tIzQ_T_e9q9',
      defaultMessage: '{nightsAndFlights}, {adultCount, plural, one {# adult} other {# adults}}',
      description: 'Context label shown beside the expanded fare options toggle in the Maldives charter mobile calendar date card',
    },
    { nightsAndFlights: nightsAndFlightsText, adultCount },
  )

  return {
    nightsText,
    priceContextText,
    expandedPriceContextText,
  }
}

export function getMaldivesDesktopCalendarPriceContextLabel(
  intl: IntlShape,
  nights: number,
  priceMode: 'total' | 'perPerson',
  adultCount: number,
) {
  return priceMode === 'perPerson' ? intl.formatMessage({
    id: 'xe2lXJIo_DCgKuC6iMHd',
    defaultMessage: '{nights, plural, one {# night} other {# nights}} & flights, per adult',
    description: 'Context text beside the per-person price mode selector in the Maldives charter calendar.',
  }, { nights }) : intl.formatMessage({
    id: '_-mEHVdhPQ3cq5PRfb04',
    defaultMessage: '{nightsLabel} & flights, {adultCountLabel}',
    description: 'Context text beside the total price mode selector in the Maldives charter calendar, explaining selected duration and adult count.',
  }, {
    nightsLabel: intl.formatMessage({
      id: '-VEGpUO57j9Em2aOuCpc',
      defaultMessage: '{nights, plural, one {# night} other {# nights}}',
      description: 'Night count in the Maldives charter calendar price context',
    }, { nights }),
    adultCountLabel: intl.formatMessage({
      id: 'YBBSbcGaRbcUhkcOnWa5',
      defaultMessage: '{adultCount, plural, one {# adult} other {# adults}}',
      description: 'Adult count in the Maldives charter calendar price context',
    }, { adultCount }),
  })
}
